export enum RowsPerPageKeys {
  INVOICES = "INVOICES_PER_PAGE",
}

export const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];

const rowsPerPageService = (key: RowsPerPageKeys) => {
  const getRowsPerPage = (): number | null => {
    try {
      const value = localStorage.getItem(key);
      if (value === null) return null;
      const parsed = Number(value);
      return ROWS_PER_PAGE_OPTIONS.includes(parsed) ? parsed : null;
    } catch (error) {
      return null;
    }
  };

  const setRowsPerPage = (value: number): void => {
    try {
      localStorage.setItem(key, String(value));
    } catch (error) {
      console.error("Error setting rows per page:", error);
    }
  };

  return {
    getRowsPerPage,
    setRowsPerPage,
  };
};

export default rowsPerPageService;
